import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectPathwayWithRules } from '@pathways/redux/pathways/reducers';
import {
  selectSharedPathway,
  selectSharedPathwaysLoading,
} from '@pathways/redux/sharedPathways/reducers';
import { fetchSharedPathwaySnapshots } from '@pathways/redux/sharedPathways/actions';
import { fetchPathways } from '@pathways/redux/pathways/actions';
import { fetchRules } from '@pathways/redux/rules/actions';
import { fetchIndexEvents } from '@pathways/redux/indexEvents/actions';
import Card from './Card';
import './style.less';

function IndexEventTriggeredRules({ pathwayId }) {
  const dispatch = useDispatch();
  const [pathwaysLoading, selectorPathway] = useSelector(state =>
    selectPathwayWithRules(state, pathwayId),
  );
  const sharedPathway = useSelector(selectSharedPathway(Number(pathwayId)));
  const sharedPathwaysLoading = useSelector(selectSharedPathwaysLoading);
  const loading = pathwaysLoading || sharedPathwaysLoading;

  useEffect(() => {
    dispatch(fetchPathways());
    dispatch(fetchSharedPathwaySnapshots());
    dispatch(fetchIndexEvents());
    dispatch(fetchRules());
  }, [dispatch]);

  return <Card loading={loading} pathway={selectorPathway?.id ? selectorPathway : sharedPathway} />;
}

export default IndexEventTriggeredRules;
